define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/config/levels-config'
], function RiqChildFormVmModule(aoflModules, levelsConfig) {
  'use strict';
  var storeService = aoflModules.store;
  var READING_LEVEL_MAP = levelsConfig.maps.groupReadingLevels.camelToSnake;

  var vmService = function vmService(
    riqUserModelService,
    riqGroupModelService,
    tagModelService,
    avatarModelService,
    placementModelService,
    modalService,
    $state
  ) {
    var ERRORS = {
      818130: {
        edit: 'badWordsError',
        create: 'badWordsError'
      },
      818156: {
        create: 'groupSizeLimitError'
      }
    };

    var getChildren = function getChildren() {
      return riqGroupModelService
        .getGroup()
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'group',
              mutationId: 'update',
              payload: payload
            }
          ]);
        })
        .catch(function(e) {
          console.error(e);
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var _profileSwapToChild = function _profileSwapToChild(profileUuid) {
      return riqUserModelService.loginAs(profileUuid);
    };

    var create = function create({useOnboardingEndpoint, profileSwap}) {
      var state = storeService.getState();
      var data = {
        name: state.riqChildForm.name,
        profileGradeLevel: state.riqChildForm.levelId,
        avatar: state.riqChildForm.avatar
      };

      return riqGroupModelService
        .addGroupProfile(data, useOnboardingEndpoint)
        .then(function(payload) {
          var profiles = state.group.profiles || [];
          var groupProfiles = profiles.concat(payload.profile);

          const commitPayload = [
            {
              stateAlias: 'group',
              mutationId: 'updateProfiles',
              payload: groupProfiles
            },
            {
              stateAlias: 'user',
              mutationId: 'updateProfiles',
              payload: groupProfiles
            },
            {
              stateAlias: 'riqChildForm',
              mutationId: 'clearData',
              payload: {}
            }
          ];

          // RIQ-3012 Prevent profile swap.
          if (profileSwap) {
            commitPayload.push({
              stateAlias: 'profile',
              mutationId: 'setUserProfile',
              payload: payload.profile
            });
            return _profileSwapToChild(payload.profile.profileUuid).then(
              function() {
                storeService.commit(commitPayload);
              }
            );
          }
          storeService.commit(commitPayload);
        })
        .catch(function(error) {
          console.error(error);
          var toastrMessage = error.code
            ? ERRORS[error.code].create
            : 'addChildError';
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: toastrMessage
            }
          ]);
        });
    };

    var _formatChildProfile = function _formatChildProfile(profile) {
      return Object.assign(
        {
          profileUuid: profile.profileUuid,
          avatarUrl: avatarModelService.getAvatarUrl(
            profile.profileDetails.avatar
          )
        },
        profile.profileDetails
      );
    };

    var update = function update({useOnboardingEndpoint}) {
      var state = storeService.getState();
      var data = {
        name: state.riqChildForm.name,
        profileGradeLevel: state.riqChildForm.level.id,
        avatar: state.riqChildForm.avatar
      };

      return riqUserModelService
        .saveUserProfile(
          data,
          state.riqChildForm.profileUuid,
          useOnboardingEndpoint
        )
        .then(function(payload) {
          const profiles = state.group.profiles || [];
          const profile = _formatChildProfile(
            payload.profile || payload.profiles[0]
          );
          const editedChildProfileDetails = profiles.map(function(_profile) {
            if (_profile.profileUuid === profile.profileUuid) {
              return Object.assign({}, _profile, {
                profileDetails: profile
              });
            }
            return _profile;
          });

          const commitPayload = [
            {
              stateAlias: 'group',
              mutationId: 'updateProfiles',
              payload: editedChildProfileDetails
            },
            {
              stateAlias: 'user',
              mutationId: 'updateProfiles',
              payload: editedChildProfileDetails
            },
            {
              stateAlias: 'riqChildForm',
              mutationId: 'clearData',
              payload: {}
            }
          ];

          // RIQ-3012 Prevent profile swap.
          if (state.profile.profileUuid === profile.profileUuid) {
            commitPayload.push(
              {
                stateAlias: 'profile',
                mutationId: 'updateProfileDetails',
                payload: profile
              },
              {
                stateAlias: 'user',
                mutationId: 'setReaderProfile',
                payload: profile
              },
              {
                stateAlias: 'level',
                mutationId: 'update',
                payload: {
                  activeTab: profile.activeReadingLevelType,
                  gradeLevel: profile.activeReadingLevel
                }
              }
            );
          }

          storeService.commit(commitPayload);
        })
        .catch(function(error) {
          console.error(error);
          var toastrMessage = error.code
            ? ERRORS[error.code].edit
            : 'editChildError';
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: toastrMessage
            }
          ]);
        });
    };

    /*
      OnboardingEndpoint is a wrapper around Group/AddProfile and Group/UpdateProfile 
      which make sure to update the onboarding steps when it creates a new profile.
      But we can not use it with RLA, because API will finish onboarding
      and there is no way for the client to know to put the user back to the select-user page.
      So As a temp workaround, I am skipping the update on purpose till we update onboarding flow 
      to include an optional RLA step.
    */
    /**
     *
     * @param {*} _ ignored argument as older version of this function was passing the payload in the first argument
     * @param {Object} config
     *        config.useOnboardingEndpoint {Boolean} If True ModelServices will use onboarding path endpoints
     *        consfig.profileSwap {Boolean} if true, create fn will force a profile swap
     * @return {Promise} Create or updateProfile Promise
     */
    var submitForm = function submitForm(_, config) {
      var state = storeService.getState();
      var formState = state.riqChildForm.formState;
      if (formState === 'create') {
        return create(config);
      } else if (formState === 'edit') {
        return update(config);
      }
    };

    var getValidPlacementLevels = function getValidPlacementLevels() {
      return placementModelService
        .getAsmtSupportedInfo()
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'setPlacementAssessmentLevels',
              payload: payload.gradeLevelIds
            }
          ]);
        })
        .catch(function(e) {
          console.error(e);
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var getGradeLevels = function getGradeLevels() {
      return tagModelService
        .getTag([READING_LEVEL_MAP.gradeLevel])
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'setLevels',
              payload: payload.tags
            }
          ]);
        })
        .catch(function(e) {
          console.error(e);
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var setLevel = function setLevel(value) {
      var state = storeService.getState();
      var levels = state.riqChildForm.levels;
      var selectedLevel = typeof value === 'object' ? value : '';
      if (!selectedLevel) {
        levels.forEach(function(level) {
          if (level.gradeLabel === value) {
            selectedLevel = level;
          }
        });
      }
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setLevel',
          payload: selectedLevel
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setErrorCode',
          payload: 0
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setInputErrors',
          payload: {}
        }
      ]);
    };

    var setAvatar = function setAvatar(value) {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setAvatar',
          payload: {
            avatar: value.avatarId,
            avatarUrl: value.url
          }
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setErrorCode',
          payload: 0
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setInputErrors',
          payload: {}
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setView',
          payload: 'childForm'
        }
      ]);
    };

    var setView = function setView(view) {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setView',
          payload: view
        }
      ]);
    };

    var setFirstName = function setFirstName(value) {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setFirstName',
          payload: value
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setErrorCode',
          payload: 0
        },
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setInputErrors',
          payload: {}
        }
      ]);
    };

    var setFormState = function setFormState(value) {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setFormState',
          payload: value
        }
      ]);
    };

    var setState = function setState(profile) {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'setState',
          payload: profile
        }
      ]);
    };

    var _getLevelObject = function _getLevelObject(profileGradeLevel) {
      var state = storeService.getState();
      return state.riqChildForm.levels.filter(function(level) {
        return level.id === profileGradeLevel;
      })[0];
    };

    var _setChildObject = function _setChildObject(profile) {
      var child = _formatChildProfile(profile);
      var level =
        typeof child.profileGradeLevel === 'object'
          ? child.profileGradeLevel
          : _getLevelObject(child.profileGradeLevel);
      setLevel(level);
      setState(child);
    };

    var getChildByProfileUuid = function getChildByProfileUuid(profileUuid) {
      return riqUserModelService
        .getUserProfile(null, profileUuid, null, false)
        .then(function(payload) {
          _setChildObject(payload.profiles[0]);
        })
        .catch(function(e) {
          console.error(e);
          $state.go('my_account_en');
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'getProfileError'
            }
          ]);
        });
    };

    var getAvatarOptions = function getAvatarOptions() {
      return riqUserModelService
        .getAvatarOptions()
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'setAvatars',
              payload: payload
            }
          ]);
        })
        .catch(function(e) {
          console.error(e);
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var init = function init(profileUuid) {
      getAvatarOptions().then(function() {
        var state = storeService.getState();
        var avatar = state.riqChildForm.avatar;
        var formCreate = state.riqChildForm.formState === 'create';
        var defaultAvatar = state.riqChildForm.avatars[0];
        if (formCreate && !avatar) {
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'setAvatar',
              payload: {
                avatar: defaultAvatar.avatarId,
                avatarUrl: defaultAvatar.url
              }
            }
          ]);
        }
      });
      getGradeLevels().then(function() {
        if (profileUuid) {
          getChildByProfileUuid(profileUuid);
        }
      });
      getValidPlacementLevels();
    };

    var deleteChild = function deleteChild(profileUuid, groupUuid) {
      return riqGroupModelService
        .removeProfileFromGroup(profileUuid, groupUuid)
        .then(function(payload) {
          modalService.closeAll();
          var state = storeService.getState();
          var groupProfiles = payload.group.profiles;
          groupProfiles.forEach(function(child, idx) {
            groupProfiles[
              idx
            ].profileDetails.avatarUrl = avatarModelService.getAvatarUrl(
              child.profileDetails.avatar
            );
          });
          var currentProfile =
            state.profile.profileUuid === profileUuid
              ? groupProfiles[0]
              : state.profile;
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'clearData',
              payload: {}
            },
            {
              stateAlias: 'group',
              mutationId: 'update',
              payload: {profiles: groupProfiles}
            },
            {
              stateAlias: 'profile',
              mutationId: 'setUserProfile',
              payload: currentProfile
            },
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'deleteChildSuccess'
            }
          ]);
          $state.go('my_account_en');
        })
        .catch(function(e) {
          console.error(e);
          modalService.closeAll();
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'deleteChildError'
            }
          ]);
          $state.go('my_account_en');
        });
    };

    var getPlacementHistory = function getPlacementHistory(profileUuid) {
      return placementModelService
        .getPlacementHistory(profileUuid)
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'riqChildForm',
              mutationId: 'setPlacementAssessment',
              payload: payload
            }
          ]);
        })
        .catch(function(e) {
          console.error(e);
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var clearData = function clearData() {
      storeService.commit([
        {
          stateAlias: 'riqChildForm',
          mutationId: 'clearData',
          payload: {}
        }
      ]);
    };

    var closeModal = function closeModal() {
      modalService.closeAll();
    };

    return {
      init: init,
      getChildren: getChildren,
      submitForm: submitForm,
      clearData: clearData,
      create: create,
      update: update,
      setFirstName: setFirstName,
      setLevel: setLevel,
      getGradeLevels: getGradeLevels,
      setAvatar: setAvatar,
      setView: setView,
      setFormState: setFormState,
      setState: setState,
      getAvatarOptions: getAvatarOptions,
      getPlacementHistory: getPlacementHistory,
      deleteChild: deleteChild,
      closeModal: closeModal
    };
  };
  return vmService;
});
